/**
 * フォームのアコーディオン動作
 * @returns { void }
 */
export const formAcc = () => {
  $( '.p-form-item__acc-head' ).click( function () {
    $( this ).toggleClass( 'is--open' );

    if ( $( this ).hasClass( 'is--open' ) ) {
      $( this ).next().slideDown( 200 );
    } else {
      $( this ).next().slideUp( 200 );
    }
  } );

  $( '.p-form-item__acc-head' ).each( function () {
    if ( $( this ).hasClass( 'is--open' ) ) {
      $( this ).next().show();
    }
  } );
}
